import { Injectable, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd004aService,
  Sgkd004aRequest,
  Sgkd004aRequestAceptInfo,
  Sgkd004aRequestPayInfo,
  Sgkd004aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd002dSgkd004aService {

  private _rsesult$ = new Subject<Sgkd004aResponse>();

  constructor(
    private sgkd004aService: Sgkd004aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKD004A_支払方法変更_受付登録API呼び出し
   * ＣＶＳ払込票／請求書払い／特定払込票
   *
   * @param visitNo 内部お客さま番号
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param time 受付時刻
   * @param payMethodDiv 支払方法コード
   * @memberof UsedSgkd002dSgkd004aService
   */
  addCsvInfo(visitNo: string, recptFixNo: string, date: string, time: string,
    payMethodDiv: string): Observable<Sgkd004aResponse> {
    return this.addPayInfo(visitNo, recptFixNo, date, time,
      {
        // 支払方法コード
        payMthdiv: payMethodDiv,
        // 申込日付
        srnDate: date,
        kohuri: {},
        yuchofrikae: {},
        crd: {},
        smssettlement:{}
      });
  }

  /**
   * SGKD004A_支払方法変更_受付登録API呼び出し
   * 口座振替
   *
   * @param visitNo 内部お客さま番号
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param time 受付時刻
   * @param kozaForm 口座振替フォーム
   * @memberof UsedSgkd002dSgkd004aService
   */
  addKouzaInfo(visitNo: string, recptFixNo: string, date: string, time: string,
    kozaForm: UntypedFormGroup): Observable<Sgkd004aResponse> {
    return this.addPayInfo(visitNo, recptFixNo, date, time,
      {
        // 支払方法コード
        payMthdiv: SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA,
        // 申込日付
        srnDate: date,
        // 口座振替
        kohuri: {
          // 口座名義（漢字）
          kohuriActknj: kozaForm.get('kohuriActknj').value,
          // 口座名義（カナ）
          kouzaMeigiKana: kozaForm.get('meigiKana').value,
          // 外部金融機関コード
          extBankfcCode: kozaForm.get('extBankfcCode').value,
          // 外部支店コード
          extBranchCode: kozaForm.get('extBranchCode').value,
          // 預金種別コード
          dptClsfy: kozaForm.get('dptClsfy').value,
          // 口座番号
          kouzaNo: kozaForm.get('kouzaNo').value,
          // 受取方法区分コード
          recivWaydiv: kozaForm.get('recivWayDivcd').value
        },
        yuchofrikae: {},
        crd: {},
        smssettlement:{}
      });
  }

  /**
   * SGKD004A_支払方法変更_受付登録API呼び出し
   * クレジット
   *
   * @param visitNo 内部お客さま番号
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param time 受付時刻
   * @param creditForm クレジットフォーム
   * @memberof UsedSgkd002dSgkd004aService
   */
  addCreditInfo(visitNo: string, recptFixNo: string, date: string, time: string,
    creditForm: UntypedFormGroup): Observable<Sgkd004aResponse> {
    return this.addPayInfo(visitNo, recptFixNo, date, time,
      {
        // 支払方法コード
        payMthdiv: SgKdConstants.CODE.PAYMETHOD.USER_CODE.CRD,
        // 申込日付
        srnDate: date,
        kohuri: {},
        yuchofrikae: {},
        // クレジット
        crd: {
          // クレ企業コード
          crdcoCode: creditForm.get('crdcomCoCode').value,
          /** 収納代行連携キー */
          crdLinkKey: creditForm.get('crdLinkKey').value,
          /** クレお客さまカナ氏名 */
          crdVisitKana: creditForm.get('cardMeigiKana').value
        },
        smssettlement:{}
      });
  }

  /**
   * SGKD004A_支払方法変更_受付登録API呼び出し
   * ＳＭＳ決済
   *
   * @param visitNo 内部お客さま番号
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param time 受付時刻
   * @param smsForm ＳＭＳ決済フォーム
   * @memberof UsedSgkd002dSgkd004aService
   */
  addSmsInfo(visitNo: string, recptFixNo: string, date: string, time: string,
    smsForm: UntypedFormGroup): Observable<Sgkd004aResponse> {
    return this.addPayInfo(visitNo, recptFixNo, date, time,
      {
        // 支払方法コード
        payMthdiv: SgKdConstants.CODE.PAYMETHOD.USER_CODE.SMS,
        // 申込日付
        srnDate: date,
        kohuri: {},
        yuchofrikae: {},
        crd: {},
        // ＳＭＳ決済
        smssettlement: {
          /** 携帯電話番号 */
          cellphonenumber: smsForm.get('cellphonenumber').value
        }
      });
  }

  /**
   * SGKD004A_支払方法変更_受付登録API呼び出し
   *
   * @param visitNo 内部お客さま番号
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param time 受付時刻
   * @param payInfo 支払情報
   * @memberof UsedSgkd002dSgkd004aService
   */
  private addPayInfo(visitNo: string, recptFixNo: string, date: string, time: string,
    payInfo: Sgkd004aRequestPayInfo): Observable<Sgkd004aResponse> {

    // リクエスト生成
    let request: Sgkd004aRequest = {
      requestDto: {
        paymentmethodchangeAceptinforegList: [
          {
            // 受付情報
            aceptInfo: this.createAceptInfo(visitNo, recptFixNo, date, time),
            // 支払情報
            payMethodInfo: payInfo,
            updateInfo: {}
          }
        ]
      }
    }

    return this.sgkd004aService.doSGKD004APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD004A');
          return throwError(err.message);
        }
      )
    );
  }

  /**
   * 受付情報の生成
   * @param visitNo 内部お客さま番号
   * @param recptFixNo 請求お客さま番号
   * @param date 受付時刻
   * @param time 受付時刻
   * @returns 受付情報
   * @memberof UsedSgkd002dSgkd004aService
   */
  private createAceptInfo(visitNo: string, recptFixNo: string, date: string,
    time: string): Sgkd004aRequestAceptInfo {
    return {
      // 内部お客さま番号
      visitNo: visitNo,
      // 請求お客さま番号
      recptFixNo: recptFixNo,
      // 受付日付
      aceptDate: date,
      // 受付時刻
      aceptHms: time,
      // 申込方法
      srnMethod: SgKdConstants.CODE.PAY_METHOD_REG_MTD_DIV.USER_CODE.ONLINE
    }
  }
}
